import { render, staticRenderFns } from "./ServicePaymentTab.vue?vue&type=template&id=28861f84&scoped=true"
import script from "./ServicePaymentTab.vue?vue&type=script&lang=js"
export * from "./ServicePaymentTab.vue?vue&type=script&lang=js"
import style0 from "./ServicePaymentTab.vue?vue&type=style&index=0&id=28861f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28861f84",
  null
  
)

export default component.exports